import React from "react";
import Modal from "react-modal";
import { Oval } from "react-loader-spinner";

import "./AcceptPlanModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    maxWidth: "460px",
    width: "90%",
  },
};

export interface AcceptPlanModalProps {
  isOpen: boolean;
  optionNumber: number; // 1-based option shown to the user
  date: string;
  loading: boolean;
  error?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// "Are you sure" confirmation for accepting an optimization plan. Accept is a
// destructive write — it replaces the drivers' existing schedule for the date.
export function AcceptPlanModal({
  isOpen,
  optionNumber,
  date,
  loading,
  error,
  onConfirm,
  onCancel,
}: AcceptPlanModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={loading ? undefined : onCancel}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div className="accept-plan-modal">
        <div className="apm-title">Accept Option {optionNumber}?</div>
        <div className="apm-message">
          This applies Option {optionNumber} to the schedule for{" "}
          <strong>{date}</strong>. It will{" "}
          <strong>override the current schedule</strong> — every existing schedule
          item for these drivers on that date is replaced.
        </div>
        {error && <div className="apm-error">{error}</div>}
        <div className="apm-buttons">
          <button
            className="apm-btn apm-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="apm-btn apm-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <Oval color="#131313" height={16} width={16} secondaryColor="#FBD20A" />
            ) : (
              "Accept & override"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}
